define(
    'LNRS/Components/Charts/pie',["jquery", "d3", "scrollMagic", "mustache", "LNRS/Components/Charts/Base"],
    function ($, d3, ScrollMagic, mustache, Base) {
        "use strict";

        function PieChart(scope, chartInfo, id) {
            Base.call(this, scope, chartInfo, id);
        }

        PieChart.prototype = Object.create(Base.prototype);

        PieChart.prototype.initChart = function initChart(gDiv, dataset) {
            var locals = {};

            var svgWidth = $(gDiv).width();
            var svgHeight = svgWidth;
    
            $(gDiv).css('padding-bottom','105%');
            $(gDiv).css('height','1px');
    
            var svg = d3.select(gDiv)
                .append('svg')
                .attr('viewBox', '0,0,'+ svgWidth + ','+ svgHeight );

            // shadow for tooltip
            var chartDefs = svg.append('defs');
            var chartFilter = chartDefs.append('filter')
                .attr('id','shadow')
                .attr('x','0')
                .attr('y','0');
            chartFilter.append('feOffset')
                .attr('result','offOut')
                .attr('in','SourceAlpha')
                .attr('dx','-5')
                .attr('dy','-5');
            chartFilter.append('feGaussianBlur')
                .attr('result','blurOut')
                .attr('in','offOut')
                .attr('stdDeviation','6');
            chartFilter.append('feBlend')
                .attr('in','SourceGraphic')
                .attr('in2','blurOut')
                .attr('mode','normal');  
        }

        PieChart.prototype.animateChart = function animateChart(gDiv, dataset) {
      
            var svg = d3.select(gDiv + " svg"),
                // add div for toolbar
                div = d3.select(gDiv).append("div").attr("class", "tooltip-c pies");

    
                var hasBeenTouchedRecently = false;
                var svgWidth = $(gDiv).width();
                var svgHeight = svgWidth;
            if(svgWidth < 200) {    
                var    margin = { top: 5, right: 5, bottom: 5, left: 5 },
                    chartWidth  = svgWidth  - margin.left - margin.right,
                    chartHeight = svgHeight - margin.top  - margin.bottom,
                    radius = chartWidth/2,
                    labelOffset = 30,
                    ttOffsetX = 20,
                    ttOffsetY = 30;
            } else if (svgWidth < 400) {
                var    margin = { top: 10, right: 10, bottom: 10, left: 10 },
                    chartWidth  = svgWidth  - margin.left - margin.right,
                    chartHeight = svgHeight - margin.top  - margin.bottom,
                    radius = chartWidth/2,
                    labelOffset = 30,
                    ttOffsetX = 20,
                    ttOffsetY = 30;
            } else {
                var margin = { top: 20, right: 20, bottom: 20, left: 20 },
                    chartWidth  = svgWidth  - margin.left - margin.right,
                    chartHeight = svgHeight - margin.top  - margin.bottom,
                    radius = chartWidth/2,
                    labelOffset = 80,
                    ttOffsetX = 60,
                    ttOffsetY = 100;
            };
        
            var chartWrapper = svg.append('g')
                .style('font-family',"'Source Sans Pro'")
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            // cleanup data - if needed
            /*
            dataset.points.forEach(function(d,i){
                d = d.map(function (x) { 
                    return parseInt(x, 10); 
                });
                dataset.points[i] = d;
            });
            */
            /*
             * check if there are enough colors 
             */

            if (dataset.colors.length && dataset.points.length) {
                while (dataset.colors.length < dataset.points[0].length) {
                    dataset.colors = dataset.colors.concat(dataset.colors);
                }
            }
    
            var p0 = chartWrapper.append('g')
                .attr('class', 'pie0')
                .attr('transform','translate(' + radius + ',' + radius + ')')    

            var sum = dataset.points.reduce(function(a, b){
                return a + b;
            }, 0);

            var pie = d3.pie()
                .sort(null)
                .value(function(d) { 
                    return d; 
                });


            var path = d3.arc()
                .outerRadius(radius - 10)
                .innerRadius(0);

            var arcZero = d3.arc()
                .innerRadius(0)
                .outerRadius(radius * 0.8);
                
            var arcOver = d3.arc()
                .innerRadius(0)
                .outerRadius(radius + 10);    
    
            var label = d3.arc()
                .outerRadius(radius - labelOffset)
                .innerRadius(radius - labelOffset);

            var timeout = setTimeout(function () {
                clearTimeout(timeout);
                var arc = p0.selectAll(".arc")
                        .data(pie(dataset.points))
                        .enter().append("g")
                            .attr("class", "arc");

                arc.append("path")
                    .attr("d", arcZero)
                    .attr('id',
                        function(d, i) {
                            return 'pie-' + i;
                        })
                    .attr("fill", function(d, i) { return dataset.colors[i]; })
                    // attach tooltips
                    .on("mouseleave", function() {
                        var div = d3.select(gDiv + " .tooltip-c");
        
                        // do nothing if open on click
                        if( div.attr('class').includes('open') ) {
                            return false;
                        }
                        div.attr('class','tooltip-c pies');
                        $(gDiv + " .tooltip-c")
                        .css("opacity",0)
                        //.css("top",0)
                        //.css("left",0)
                        ;
                        d3.select(this)
                            .transition()
                            .duration(400)
                            .attr('d', path)
                            .attr("stroke","none");
                    })
                    .on("mousemove",function(){
                        var div = d3.select(gDiv + " .tooltip-c");
                        var currPos = $(this).attr('id');
        
                        // do nothing if open on click
                        if( div.attr('class').includes('open') ) {
                            return false;
                        }
                        //if on the same slice do nothing
        //                if( div.attr('class').includes(currPos)) {
        //
        //                } else {
                            var eventX = d3.event.pageX;
                            var eventY =d3.event.pageY;
        
                            // add class for current slice
                            div.attr('class','tooltip-c pies ' + currPos)
                            var offset = $(gDiv).offset();
                            var currArrPos = currPos.split('-');
        
                            div.html("<p style='color:#000;font-size:10px;'>" + dataset.segmentTitles[currArrPos[1]] + "</p>" +
                                        "<p style='color:"+dataset.colors[currArrPos[1]]+"'>"+ d3.format(".0f")(dataset.points[currArrPos[1]]) + " (" + d3.format(".0%")(dataset.points[currArrPos[1]] / sum ) + ")</p>");
        
                            $(gDiv + " .tooltip-c").css('display','block');
                            var ttBox = div.node().getBoundingClientRect();
            
                            $(gDiv + " .tooltip-c").css("left", (eventX - offset.left - ttBox.width/2  )+"px")
                                .css("top", (eventY - offset.top - ttBox.height - 20) +"px")
                                .css("opacity", 1);
            
        //                }
                    })
                    .on("mouseup touchend",function(){
                        d3.event.stopPropagation();
                        if(hasBeenTouchedRecently) {
                            return false;
                        }
                        hasBeenTouchedRecently = true;
                        setTimeout(function() { 
                            hasBeenTouchedRecently = false; 
                        }, 500);
                
                        var eventX = 0,
                            eventY =0;
                        if (d3.event.type == 'touchend') {
                            eventX = d3.event.changedTouches[0].pageX;
                            eventY = d3.event.changedTouches[0].pageY;
                        } else if (d3.event == 'mouseup') {
                            eventX = d3.event.pageX;
                            eventY =d3.event.pageY;
                        } else {
                            eventX = d3.event.pageX;
                            eventY =d3.event.pageY;
                        }
        
                        var div = d3.select(gDiv + " .tooltip-c");
                        var currPos = $(this).attr('id');
        
                        if( div.attr('class').includes('open') && div.attr('class').includes(currPos)) {
                            div.attr('class','tooltip-c pies');
                            $(gDiv + " .tooltip-c")
                            .css("opacity",0)
                            //.css("top",0)
                            //.css("left",0)
                            ;
                            d3.select(this)
                                .transition()
                                .duration(400)
                                .attr('d', path)
                                .attr("stroke","none");
                            return;
                        };
                        div.attr('class','tooltip-c pies open ' + currPos)
        
                        var offset = $(gDiv).offset();
                        var currArrPos = currPos.split('-');
                        var currX; 
                        var dd = d3.touches();
                        //var f = d3.format(dataset.tooltipFormat);
                        div.html("<p style='color:#000;font-size:10px;'>" + dataset.segmentTitles[currArrPos[1]] + "</p>" +
                                    "<p style='color:"+dataset.colors[currArrPos[1]]+"'>"+ d3.format(".0f")(dataset.points[currArrPos[1]]) + " (" + d3.format(".0%")(dataset.points[currArrPos[1]] / sum ) + ")</p>");
                        $(gDiv + " .tooltip-c").css('display','block');
                        var ttBox = div.node().getBoundingClientRect();
        
                        $(gDiv + " .tooltip-c").css("left", (eventX - offset.left - ttBox.width/2  )+"px")
                            .css("top", (eventY - offset.top - ttBox.height - 20) +"px")
                            .css("opacity", 1);
                            
                    },this)
                .style("opacity", "0.0") 
                .transition()
                .duration("800")                
                .style("opacity", "1.0")
                .delay(function(d,i){ return (200*i)})
                .attr('d', path );                
                
                arc.append("text")
                    .attr("transform", function(d) { return "translate(" + label.centroid(d) + ")"; })
                    .attr('dy','5')
                    .text(function(d,i) { 
                        if ( !((d.value / sum < .06) && (svgWidth < 300)) ){
                            return d3.format(".0%")(d.value / sum ); 
                        }
                    })
                    .attr('text-anchor','middle')
                    .attr("font-weight","bold")
                    .attr("fill","#fff")
                    .style("pointer-events","none");                

            }, 1500*dataset.delayIndex);

            // add event to any click on svg
            $(gDiv).on('mouseup touchend', function(){
                if(hasBeenTouchedRecently) {
                    return false;
                }
                $(gDiv + " .tooltip-c")
                    .css("opacity","0")
                    .attr('class','tooltip-c pies');
        
            });

        }

        return function initPieChart(args) {
            return args.IsExperienceEditorEditing ? null : new PieChart(
                args.scope,
                args.chartInfo,
                args.id);
        };
    });
